import {useTranslation, TKey} from '@/translations/i18n.tsx'
import {UploadButtons} from '@features/assignment/components/upload-buttons'
import {FC} from 'react'
import {Assignment, ServiceType} from '@features/assignment/types'
import {WalkthroughFormButton} from '@features/assignment/components/walkthrough-form-button'
import {AssignmentVideoButtons} from '@features/assignment/components/assignment-video-buttons'
import {ThreeDScanCard} from '@features/assignment/components/three-d-scan-card'
import {envVars} from '@/envVars.ts'
import {
    ASSIGNMENT_DESCRIPTION_PARAGRAPH_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_TEXT_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_WRAPPER_CLASSNAME
} from '@features/assignment/constants'

export const UploadAssetsDescription: FC<{
    assignment: Assignment
    serviceType: ServiceType
}> = ({assignment, serviceType}) => {
    const {t} = useTranslation()

    const title =
        serviceType == 'walkthrough' ? t('assignment:submit_form') : t('assignment:descriptions:pending_assets:title')
    const paragraph = t(`assignment:descriptions:pending_assets:paragraph:${serviceType}` as TKey)
    const actionButtons =
        assignment.task_media.name == 'walkthrough' ? (
            <WalkthroughFormButton assignment={assignment} />
        ) : assignment.task_category.name == 'Experiences' && assignment.task_media.name == 'video' ? (
            <AssignmentVideoButtons assignment={assignment} />
        ) : (
            <UploadButtons assignment={assignment} />
        )

    if (envVars.VITE_IS_FLOOR_PLAN_ENABLED && assignment.is_3d_scan) {
        return (
            <div className="flex flex-col gap-6">
                <h3 className={ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME}>{title}</h3>
                <ThreeDScanCard assignment={assignment} />
                <div className="flex flex-col gap-2 w-full rounded-xl border border-neutral-300 bg-white p-6 md:rounded-2xl">
                    <h3 className="text-lg font-medium text-neutral-900">
                        {t('assignment:three_d_scan:photoshoot_assets_title')}
                    </h3>
                    <div className="flex w-full flex-col items-stretch justify-between gap-6 md:flex-row md:items-end *:last:shrink-0">
                        <div className="flex flex-col gap-3 w-full">
                            <p className="text-sm whitespace-pre-line text-neutral-900">{paragraph}</p>
                        </div>
                        {actionButtons}
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={ASSIGNMENT_DESCRIPTION_WRAPPER_CLASSNAME}>
            <div className={ASSIGNMENT_DESCRIPTION_TEXT_CLASSNAME}>
                <h3 className={ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME}>{title}</h3>
                <p className={ASSIGNMENT_DESCRIPTION_PARAGRAPH_CLASSNAME}>{paragraph}</p>
            </div>
            {actionButtons}
        </div>
    )
}
